module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAABZklEQVQ4T5XTv6vOYRzG8dfHr/xKFnUGBtkkGRisDAYlhkOIxSaLjcmiSDKbpMRkschgUSfLGZwO/4AJKeVEdBxuXcf9PB16Ho67vtPn/r6/1+e6rm9Ba62wHycwjYdV9TWz5Zxqra3AblzCQdzHlar62OFDTlW1UdBADuA8DuML7uFJBGLlHy/9wGe8weuqms88kEc4hDX4hjksZNafpZyAM3uFu3hcVXOBXMUZbOtKXuLdCBUBrMJWbMd73AoskC04jouYwJ0+jOyoGZxA4t8OnMVJvMXlxUuttU04hXN4EZOr6sMoE7vZUX0dR/F0+KUO2otPmBmYNgaUtU7jBuaXyh30xbgoh3v96lXSvI3Vv0GWU6y+/jpciB8J4b8g3Y/12IOb2DlIJ4kksrW9YOMEpR9RsA/HsAtTi+m01q7hCDb8A5K2psGbe/TPu5pngSSqSWzE97/4ktXTlUSf3+IBZqtq4SfGCntx9b44TQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/backBtn.png
// module id = OM46
// module chunks = 2